import React, { useCallback, useEffect, useState } from "react";
import { endpointsCf } from "../../config/componentsConfig";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import styles from "./ChunkIndicesHealth.module.scss";

type ChunkMode = "market" | "mydeal" | "oreima" | "legal";

type ChunkHealthEntry = {
  index: string;
  count: number;
  healthy: boolean;
  error?: string;
};

type ChunkHealthResponse = Partial<Record<ChunkMode, ChunkHealthEntry>>;

const MODES: { mode: ChunkMode; label: string }[] = [
  { mode: "market", label: "Market" },
  { mode: "mydeal", label: "MyDeal" },
  { mode: "oreima", label: "Oreima" },
  { mode: "legal", label: "Legal" },
];

const POLL_MS = 60_000;

const ChunkIndicesHealth: React.FC = () => {
  const { execute } = useFetchWithMsal();
  const [health, setHealth] = useState<ChunkHealthResponse>({});

  const refresh = useCallback(async () => {
    const data = (await execute(
      "GET",
      endpointsCf.chunksHealth()
    )) as ChunkHealthResponse | undefined;
    if (data) {
      setHealth(data);
    }
  }, [execute]);

  useEffect(() => {
    refresh();
    const id = window.setInterval(refresh, POLL_MS);
    return () => window.clearInterval(id);
  }, [refresh]);

  return (
    <div
      className={styles.wrapper}
      role="status"
      aria-label="Statut des index Elasticsearch de chunks"
    >
      {MODES.map(({ mode, label }) => {
        const entry = health[mode];
        const healthy = entry === undefined ? true : entry.healthy === true;
        const count = entry?.count ?? 0;
        const title = entry
          ? `${label} (${entry.index}): ${count.toLocaleString()} chunk${
              count === 1 ? "" : "s"
            }${entry.error ? ` — ${entry.error}` : ""}`
          : `${label}: vérification en cours…`;
        return (
          <span key={mode} className={styles.item} title={title}>
            <span
              className={`${styles.dot} ${
                healthy ? styles.dotOk : styles.dotKo
              }`}
              aria-hidden="true"
            />
            <span className={styles.label}>{label}</span>
          </span>
        );
      })}
    </div>
  );
};

export default ChunkIndicesHealth;
